export default __webpack_public_path__ + "static/ProximaNova-Medium-703b9335faec412a9e6ee03ae5c515f6.woff2";